import { combineReducers } from 'redux';

import auth from './auth';
import user from './user';
import map from './map';
import menu from './menu';
import messages from './messages';
import search from './search';
import editor from './editor';
import input from './input';
import schools from './schools';
import classes from './classes';
import teachers from './teachers';
import lessons from './lessons';
import pins from './pins';
import templates from './templates';
import places from './places';
import slideShows from './slideShows';
import activities from './activities';
import introductions from './introductions';
import institutions from './institutions';

export default combineReducers({
  auth,
  user,
  map,
  menu,
  messages,
  search,
  editor,
  input,
  schools,
  classes,
  teachers,
  lessons,
  pins,
  templates,
  places,
  slideShows,
  activities,
  introductions,
  institutions,
});



// WEBPACK FOOTER //
// ./src/store/modules/index.js